const { REACT_APP_STAGE } = process.env;
const currentEnv = REACT_APP_STAGE as keyof typeof endpointMap;
const endpointMap = {
  dev: "https://e4ggttis22.execute-api.eu-west-1.amazonaws.com/dev/",
  prod: "https://97bcvkd0r7.execute-api.eu-west-1.amazonaws.com/prod/",
};

export const endpoint = endpointMap[currentEnv]
export default endpoint;